<script>
  import DrugSearch from '../DrugSearch/DrugSearch.svelte';
  import { getStaticMapImageSrc } from '../../utils/static-map.ts';
  import { page } from '$app/stores';
  
  let {
    headingText = $bindable(),
    headingLevel = 'h1',
    drugSearch,
    lat,
    lng,
    mapAlt,
    dataTestId = 'search-promo-city',
    lang,
  } = $props();

  // remove html tags from heading content
  headingText = headingText && headingText.content ? headingText.content.replace(/<\/?[^>]+(>|$)/g, '') : undefined;

  // Mapbox Image Configuration
  const userAgent = $page.data && $page.data.userAgent;

  const mapboxDetails = {
    lat,
    hideMarker: true,
    theme: 'light-v10',
    userAgent
  }

  const smallOptions = {
    width: 768,
    height: 286,
    lng: (parseFloat(lng) - 0.15).toString(),
    zoom: 10,
    ...mapboxDetails
  };

  const mediumOptions = {
    width: 1024,
    height: 480,
    lng: (parseFloat(lng) - 0.2).toString(),
    zoom: 10,
    ...mapboxDetails
  };

  const largeOptions = {
    width: 1152,
    height: 480,
    lng: (parseFloat(lng) - 0.095).toString(),
    hideMarker: true,
    zoom: 11,
    ...mapboxDetails
  };

  const smallDefaultSrc = getStaticMapImageSrc(smallOptions);
  const smallHighResSrc = getStaticMapImageSrc({ ...smallOptions, highRes: true });
  const mediumDefaultSrc = getStaticMapImageSrc(mediumOptions);
  const mediumHighResSrc = getStaticMapImageSrc({ ...mediumOptions, highRes: true });
  const largeDefaultSrc = getStaticMapImageSrc(largeOptions);
  const largeHighResSrc = getStaticMapImageSrc({ ...largeOptions, highRes: true });
</script>

<svelte:head>
  <link rel="preconnect" href={process.env.MAPBOX_API_BASE_URL} />
</svelte:head>

<div class="flex justify-center relative bg-blue-very-light" data-testid={dataTestId}>
  <div class="absolute hidden md:block h-full top-0 right-0 bottom-0 left-0">
    <picture>
      <source media="(min-width: 1280px)" srcset={`${largeDefaultSrc}, ${largeHighResSrc} 2x`} />
      <source media="(max-width: 1279px)" srcset={`${mediumDefaultSrc}, ${mediumHighResSrc} 2x`} />
      <source media="(min-width: 768px)" srcset={`${smallDefaultSrc}, ${smallHighResSrc} 2x`} />
      <source
        media="(max-width: 767px)"
        srcset="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
      />
      <img
        class="h-full w-full object-cover object-right ml-auto mix-blend-luminosity"
        src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
        width="768"
        height="286"
        alt={mapAlt}
      />
    </picture>
    <div class="h-full absolute top-0 right-0 bottom-0 left-0"></div>
  </div>
  <div class="flex items-center relative max-w-100 md:w-full md:max-w-full md:min-h-56 lg:min-h-120 lg:max-w-6xl">
    <div
      class="w-full md:w-2/3 lg:w-3/5 xl:w-1/2 md:pr-0 md:items-start p-4 md:py-16 lg:pl-1 lg:py-20 md:relative flex flex-col items-center lg:mb-4"
    >
      {#if headingText}
        {#if headingLevel === 'h1'}
          <h1
            class="ml-3 md:relative md:z-10 mb-4 md:mb-6 px-3 md:px-0 text-center leading-tight text-blue-navy
            text-1.5xl md:text-2xl lg:text-3xl md:text-left"
            data-testid="search-promo-city-heading"
          >
            {@html headingText}
          </h1>
        {:else if headingLevel === 'h2'}
          <h2
            class="ml-3 md:relative md:z-10 mb-4 md:mb-6 px-3 md:px-0 text-center leading-tight text-blue-navy
            text-1.5xl md:text-2xl lg:text-3xl md:text-left"
            data-testid="search-promo-city-heading"
          >
            {@html headingText}
          </h2>
        {:else if headingLevel === 'h3'}
          <h3
            class="ml-3 md:relative md:z-10 mb-4 md:mb-6 px-3 md:px-0 text-center leading-tight text-blue-navy
            text-1.5xl md:text-2xl lg:text-3xl md:text-left"
            data-testid="search-promo-city-heading"
          >
            {@html headingText}
          </h3>
        {:else}
          <h4
            class="ml-3 md:relative md:z-10 mb-4 md:mb-6 px-3 md:px-0 text-center leading-tight text-blue-navy
            text-1.5xl md:text-2xl lg:text-3xl md:text-left"
            data-testid="search-promo-city-heading"
          >
            {@html headingText}
          </h4>
        {/if}
      {/if}
      <DrugSearch {...drugSearch} {lang} />
    </div>
  </div>
</div>
